// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-draggable {
    border: 1px dashed #FF7233 !important;
}

.widget-draggable:hover {
    border: 1px solid #FF7233 !important;
    background-color: rgba(255, 114, 51, 0.05);
}
`, "",{"version":3,"sources":["webpack://./src/Componant/Dashboard/WidgetSidebar/WidgetSidebar.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;AAC9C","sourcesContent":[".widget-draggable {\n    border: 1px dashed #FF7233 !important;\n}\n\n.widget-draggable:hover {\n    border: 1px solid #FF7233 !important;\n    background-color: rgba(255, 114, 51, 0.05);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
